var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{ 'timeout': _vm.timeout },staticStyle:{"color":"#02A7F0"}},[_vm._v(_vm._s(_vm.newValue))])
}
var staticRenderFns = []

export { render, staticRenderFns }